module.exports = __webpack_public_path__ + "static/media/3.a6cc743d.JPG";